import template from './rw-retailer-id.html';

export default {
  template,
  bindings: {
    retailerId: '<'
  },
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-retailer-id/rw-retailer-id-component.js